import { OrderState } from "../../api/models/unified";
import { TableQuery } from "../../common/models";

export const OrderStateArray: OrderState[] = ["Cancelled", "Completed", "Open"];

export interface OrderTableQuery extends TableQuery {
  orderState?: string | null;
  serviceObjectId?: string | null;
}

export interface OrderCustomFormTableQuery extends TableQuery {
  orderId?: string | null;
}
